import type { ReactNode } from 'react'

export function PageHeader({ title, actions }: { title: ReactNode; actions?: ReactNode }) {
  return (
    <header className="flex h-14 items-center justify-between border-b bg-background px-6">
      <h1 className="font-display text-display flex items-center gap-3">{title}</h1>
      {actions}
    </header>
  )
}
